import React from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import { useCRM } from '../../context/CRMContext';
import CRMKanbanColumn from './CRMKanbanColumn';
import { useAuth } from '../../context/AuthContext';

const CRMKanbanBoard = () => {
    const { columns, moveCard } = useCRM();
    const { checkAccess } = useAuth();

    const onDragEnd = (result) => {
        if (!checkAccess('crm.edit')) return;
        const { source, destination } = result;
        if (!destination) return;
        if (
            source.droppableId === destination.droppableId &&
            source.index === destination.index
        ) return;
        moveCard(source.droppableId, destination.droppableId, source.index, destination.index);
    };

    if (!columns || Object.keys(columns).length === 0) {
        return (
            <div className="flex items-center justify-center h-full text-sm text-gray-400 p-10">
                No pipeline columns configured.
            </div>
        );
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div className="inline-flex gap-3 sm:gap-4 px-0 py-1 sm:py-2 h-full min-h-[500px] items-start">
                {Object.entries(columns).map(([columnId, column]) => (
                    <CRMKanbanColumn
                        key={columnId}
                        columnId={columnId}
                        column={column}
                    />
                ))}
            </div>
        </DragDropContext>
    );
};

export default CRMKanbanBoard;